import React, { cloneElement, FC, HTMLAttributes, ReactElement, ReactNode, useCallback, useRef, useState } from "react";
import classNames from "classnames";
import { Manager, Popper, Reference } from "react-popper";
import themeConfig from "../../config/theme.config";
import Portal from "../admin/layouts/Portal/Portal";
import Icon from "../icon/Icon";

const getComponentName = (child) => {
  // @ts-ignore
  return child?.props["data-component-name"] || child?.type?.displayName || child?.type;
};

const Tooltip = (props) => {
  const {
    children,
    className,
    text,
    placement = "top",
    borderWidth = "border",
    rounded = themeConfig.rounded,
    ...rest
  } = props;

  const [isOpen, setIsOpen] = useState(false);

  const referenceRef = useRef(null);
  const setReferenceRef = useCallback((node, ref) => {
    referenceRef.current = node;
    return ref(node);
  }, []);

  const popperRef = useRef(null);
  const setPopperRef = useCallback((node, ref) => {
    popperRef.current = node;
    return ref(node);
  }, []);

  const REFERENCE_PROPS = {
    onMouseEnter: () => setIsOpen(true),
    onMouseLeave: () => setIsOpen(false),
  };

  return (
    <Manager>
      <Reference>
        {({ ref }) =>
          ["string", "undefined"].includes(typeof children) ? (
            <span
              data-component-name="Tooltip/Reference"
              ref={(node) => setReferenceRef(node, ref)}
              className="cursor-pointer"
              {...REFERENCE_PROPS}
            >
              {children || <Icon icon="HeroInformationCircle" className={classNames("inline-flex", className)} />}
            </span>
          ) : (
            cloneElement(children, {
              "data-component-name": `${getComponentName(children)} is cloned with Tooltip`,

              ref: (node) => setReferenceRef(node, ref),

              className: classNames("cursor-pointer", children.props.className),
              ...REFERENCE_PROPS,
            })
          )
        }
      </Reference>
      {isOpen && text !== "" && (
        <Portal>
          <Popper placement={placement}>
            {({ ref, style }) => (
              <div
                data-component-name="Tooltip/Popper"
                ref={(node) => setPopperRef(node, ref)}
                style={style}
                className={classNames(
                  "z-[9999] m-2 px-2 py-1",
                  "max-w-xs",
                  "border-zinc-500/10 shadow-lg backdrop-blur-sm",
                  [`${borderWidth}`],
                  [`${rounded}`],
                  className
                )}
                {...rest}
              >
                {text}
              </div>
            )}
          </Popper>
        </Portal>
      )}
    </Manager>
  );
};
Tooltip.displayName = "Tooltip";

export default Tooltip;
